import { render, staticRenderFns } from "./AR1.vue?vue&type=template&id=36e528fe&scoped=true"
import script from "./AR1.vue?vue&type=script&lang=js"
export * from "./AR1.vue?vue&type=script&lang=js"
import style0 from "./AR1.vue?vue&type=style&index=0&id=36e528fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e528fe",
  null
  
)

export default component.exports